import { Brain } from '@heidi/schema/ml-scribe';

// `mapNewBrain` moved to `@heidi/session/data` with the D3 family (the
// session fetch core normalizes `consult_note.brain` through it); imported +
// re-exported (this module's own helpers below still call it) so existing
// importers keep resolving until Z1's codemod.
import { mapNewBrain } from '@heidi/session/data';

export { mapNewBrain };

export const getBrainTranslationStringBase = (brain: Brain, isFreeUser: boolean) => {
  if (isFreeUser) {
    return brain === Brain.LEFT ? 'free' : 'pro';
  } else {
    return brain === Brain.LEFT ? 'fast' : 'best';
  }
};

export const FreeBrains = [Brain.LEFT];
export const PaidBrains = [Brain.RIGHT];
export const AllBrains = [...FreeBrains, ...PaidBrains];

export const isFreeBrain = (brain: Brain, isFreeUser: boolean | undefined): boolean => {
  const mappedBrain = mapNewBrain(brain, isFreeUser);
  return FreeBrains.includes(mappedBrain);
};

export const isPaidBrain = (brain: Brain, isFreeUser: boolean | undefined): boolean => {
  const mappedBrain = mapNewBrain(brain, isFreeUser);
  return PaidBrains.includes(mappedBrain);
};
